import { Controller } from "@hotwired/stimulus";

// ログインが必要なモーダルの制御を行うStimulusコントローラー
export default class extends Controller {
  connect() {
    $("#login-required").on("show.bs.modal", this.#show);
  }

  disconnect() {
    $("#login-required").off("show.bs.modal", this.#show);
  }

  #show = (ev) => {
    const modalText = $("#login-required-reason");
    const reason =
      $(ev.relatedTarget).data("reason") ||
      modalText.data("reason-" + $(ev.relatedTarget).data("class"));
    modalText.text(reason);
  };
}
